import { RED_LIST_INDEX_FLYWAYS } from '@/constants/stateCharts';

import type {
  RedListIndexFlywayId,
  RedListIndexSeriesId,
} from '@/constants/stateCharts';
import type {
  RedListIndexData,
  RedListIndexPoint,
  RedListIndexStats,
} from '@/content/data/charts/red-list-index';

/**
 * Resolve the plotted series + side stats for the active flyway filter.
 * All flyways uses the imported `all` series for its summary statistics.
 */
export function selectRedListIndexSeries(
  data: RedListIndexData,
  flywayFilter: RedListIndexSeriesId,
): {
  series: RedListIndexPoint[];
  stats: RedListIndexStats;
} {
  return {
    series: [...data.seriesByFilter[flywayFilter]],
    stats: data.statsByFlyway[flywayFilter],
  };
}

export type RedListIndexFlywaySeries = {
  id: RedListIndexFlywayId;
  points: RedListIndexPoint[];
};

/** Resolve each named flyway series for the aggregate comparison chart. */
export function selectAllRedListIndexFlywaySeries(
  data: RedListIndexData,
): RedListIndexFlywaySeries[] {
  return RED_LIST_INDEX_FLYWAYS.map((id) => ({
    id,
    points: [...data.seriesByFilter[id]],
  }));
}
